var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconMiniArrowUpLine extends Component {
  constructor() {
    super(...arguments);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconMiniArrowUp",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M994.034 694.296c-18.796-27.296-49.269-27.3-68.067 0l-351.074 509.836c-18.797 27.296-7.18 49.424 25.959 49.424h718.297c33.133 0 44.757-22.125 25.959-49.424L994.034 694.296Z",
      fillRule: "evenodd"
    })));
  }
}
IconMiniArrowUpLine.glyphName = 'mini-arrow-up';
IconMiniArrowUpLine.variant = 'Line';
IconMiniArrowUpLine.displayName = 'IconMiniArrowUpLine';
IconMiniArrowUpLine.propTypes = {
  ...SVGIcon.propTypes
};
IconMiniArrowUpLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMiniArrowUpLine;
export { IconMiniArrowUpLine };